const reorder = document.querySelector('.reorder');
if (reorder) {
    const reorder_closes = document.querySelectorAll('.reorder__close');

    for (const reorder_close of reorder_closes) {
        reorder_close.addEventListener('click', function () {
            reorder.classList.remove('is-active')
            localStorage.setItem('seen-reorder', 'true');
        });
    }

    if (localStorage.getItem('seen-reorder') != 'true') {
        if (window.location.href.indexOf("checkout") > -1 || window.location.href.indexOf("cart") > -1) {
        } else {
            reorder.classList.add('is-active')
        }
    }
}
